import React from "react";

import { ISO639_1_LANGUAGES, type ISO639_1_Language } from "@shared/types";
// @ts-ignore - CommonJS module without types
import convert3To1 from "iso-639-3-to-1";
import { franc } from "franc";

export function useDetectLanguage(
	onChange: (language: ISO639_1_Language) => void,
) {
	return React.useCallback(
		(value: string) => {
			const detected = franc(value);
			if (detected === "und") return; //language not detected

			if (detected === "cmn") {
				onChange(getChineseLanguage(value));
				return;
			}

			if (detected === "por") {
				onChange(getPortugueseLanguage(value));
				return;
			}

			if (detected === "ind") {
				onChange("id"); //convert3To1 returns "ms" for indonesian
				return;
			}

			const isoCode = convert3To1(detected) as ISO639_1_Language | undefined;
			if (isoCode && ISO639_1_LANGUAGES.includes(isoCode)) {
				onChange(isoCode);
			}
		},
		[onChange],
	);
}

function getChineseLanguage(text: string): ISO639_1_Language {
	// A small set of traditional-only characters for detection
	const traditionalChars = /[體廣漢學臺龍門風氣]/;
	if (traditionalChars.test(text)) {
		return "zh_tw";
	}
	return "zh_cn";
}

function getPortugueseLanguage(text: string): ISO639_1_Language {
	// A small set of brazilian portuguese characters for detection
	const brazilWords = /\b(fato|ótimo|ação|ônibus|trem|você)\b/i;
	if (brazilWords.test(text)) {
		return "pt_br";
	}
	return "pt_pt";
}
